export default __webpack_public_path__ + "static/flavorCrmImage-3bcc8997d996bb54aeabec9fe2e28c86.webp";